module.exports = __webpack_public_path__ + "assets/img/s2-subtitle-1-44731ad1.png";